import Vue from 'vue';
import { getDashboardStructures, updateStructure, getStructureDetails } from '../../api/structure';

const state = {
  currentObject: {
    id: null,
    displayName: ''
  },
  currentDashboard: {
    title: null,
    structures: []
  },
  structureDetails: {

  }
};

const getters = {
  dashboardStructureById: state => id => {
    return state.currentDashboard.structures.find(structure => structure.id == id);
  },
  structureDetailById: state => id => {
    return state.structureDetails[id];
  }
};

const actions = {
  async fetchForCurrentObject({ state, rootState, commit }) {
    const objectData = await getDashboardStructures(rootState.user.authTokens.accessToken, state.currentObject.id,
      {
        fullText: rootState.dashboardFilter.fullText,
        types: rootState.dashboardFilter.showSelect,
      });

    commit('setCurrentDashboard', objectData.data);
  },

  async updateStructure({ rootState, commit }, { structureId, data }) {
    const response = await updateStructure(rootState.user.authTokens.accessToken, structureId, data);
    if(response.data.ok){
      commit('updateDashboardStructure', {
        structureId, data
      })
    }
  },

  async getStructureDetails({rootState, commit }, { structureId }){
    const response = await getStructureDetails(rootState.user.authTokens.accessToken, structureId);

    if(response.data.ok){
      commit('setStructureDetail', response.data);
    }
  }
};

const mutations = {
  setCurrentStructure(state, object){
    Vue.set(state, 'currentObject', object);
  },
  setCurrentDashboard(state, object){
    Vue.set(state, 'currentDashboard', object);
  },
  updateDashboardStructure(state, object){
    for (let i = 0; i < state.currentDashboard.structures.length; i++) {
      const structure = state.currentDashboard.structures[i];
      if(structure.id == object.structureId){
        state.currentDashboard.structures[i].adminDescription = object.data.description;
      }
    }
  },
  setStructureDetail(state, object){
    Vue.set(state.structureDetails, object.structure.id, object);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
